import { uniq } from "lodash-es";
import { scanSourceSegments } from "./sourceSegments.js";
// Cross-item reference encoding for expression strings.
//
// This module is the single source of truth for the expression
// reference-encoding helpers (MEIS-12633). It is pure string operations, pulling
// only the layer's equally pure lexical scanner, and therefore browser-safe; it
// is exposed at the dedicated `@msys/document-expressions/references` subpath
// export so browser consumers can use it without pulling the layer's node-only
// code (`node:crypto` in the dependency graph, `@babel/*` in the rewrite helpers).
const uuidPattern = `[a-f0-9]{8}_[a-f0-9]{4}_[a-f0-9]{4}_[a-f0-9]{4}_[a-f0-9]{12}`;
const commaUuidPattern = "(" + uuidPattern + "(ZZZ" + uuidPattern + "){0,}" + ")+";
const idRegex = new RegExp("\\$item_" + commaUuidPattern, "g");
/** Sentinel used inside expressions to denote an explicit `null` result. */
export const __NULL__ = { __NULL__: "__NULL__" };
export function encodeItemIdAsExprVar(id) {
    return "$item_" + id.replace(/-/g, "_").replace(/,/g, "ZZZ");
}
export function decodeItemIdFromExpr(id) {
    return id.substring(6).replace(/_/g, "-").replace(/ZZZ/g, ",");
}
export function getReferencedItemIdsInExpr(expr) {
    const code = scanSourceSegments(expr)
        .filter(s => s.kind === "code")
        .map(s => s.text)
        .join(" ");
    return uniq([...code.matchAll(idRegex)]
        .flatMap(r => (r[0] ? [r[0]] : []))
        .map(id => decodeItemIdFromExpr(id)));
}
//# sourceMappingURL=references.js.map